export default function LBLogo({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="LB Trade Advisory"
      data-testid="lb-logo"
    >
      <rect width="64" height="64" rx="7" fill="#102434" />
      <rect x="7" y="7" width="50" height="50" fill="none" stroke="#b9a276" strokeWidth="2.2" />
      <rect x="11.5" y="11.5" width="41" height="41" fill="none" stroke="#b9a276" strokeWidth="0.8" opacity="0.5" />
      <text
        x="32"
        y="34.5"
        textAnchor="middle"
        fontFamily="'Playfair Display', Georgia, serif"
        fontSize="19"
        fontWeight="600"
        fill="#f5f3ee"
        letterSpacing="2"
      >
        LB
      </text>
      <rect x="21" y="40.5" width="22" height="1.5" fill="#b9a276" />
      <rect x="29" y="47" width="6" height="6" fill="#d8c08e" transform="rotate(45 32 50)" />
    </svg>
  );
}
